module.exports = __webpack_public_path__ + "static/img/lizi1.e2d43a45.png";